<template>
    <div class="content pa-6 pa-md-8 pb-6 contact my-12">
        <v-row>
            <v-col class="d-flex justify-center pt-0">
                <h1 class="text-center">What can we do for you today?</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pb-0">
                <form>
                    <v-row>
                        <v-col cols="12" sm="6" md="6" class="pb-0">
                            <v-text-field
                                    v-model="name"
                                    :error-messages="nameErrors"
                                    label="Full Name"
                                    required
                                    outlined
                                    class="btn-edu-height"
                                    @blur="$v.name.$touch()"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="pb-0">
                            <v-select
                                    v-model="select"
                                    :items="items"
                                    :error-messages="selectErrors"
                                    label="Choose one..."
                                    required
                                    outlined
                                    dense
                                    class="btn-edu-height"
                                    @change="$v.select.$touch()"
                                    @blur="$v.select.$touch()"
                                    hide-details="auto"
                            >
                                <template slot="append">
                                    <span>
                                        <v-icon size="18">mdi-chevron-down</v-icon>
                                    </span>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field
                                    v-model="email"
                                    :error-messages="emailErrors"
                                    label="Email Address"
                                    required
                                    outlined
                                    class="btn-edu-height"
                                    @blur="$v.email.$touch()"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field
                                    v-model="phone"
                                    :error-messages="phoneErrors"
                                    label="Phone Number (optional)"
                                    outlined
                                    class="btn-edu-height"
                                    @input="formatPhoneNumber"
                                    @blur="$v.phone.$touch()"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-textarea
                                    v-model="message"
                                    outlined
                                    name="input-7-7"
                                    label="Message"
                                    value=""
                                    class="btn-edu-height"
                                    :error-messages="messageErrors"
                                    @blur="$v.message.$touch()"
                                    hide-details="auto"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0 privacy">
                            <v-checkbox
                                        label="I HAVE READ AND UNDERSTOOD THE TERMS AND PRIVACY POLICY AND AGREE TO RECEIVE PERSONALIZED COMMERCIAL COMMUNICATION FROM EDURENT BY EMAIL AND SMS."
                                        class="py-0 consent-text"
                                        v-model="allow_subscription"
                                        default="true"
                                        hide-details
                            >
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-btn
                                    @click="submit"
                                    color="primary"
                                    block
                                    class="btn-edurent"
                                    height="45"
                                    :loading="isSendingMessage"
                            >
                                Send Message
                            </v-btn>
                        </v-col>
                    </v-row>
                </form>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { required, maxLength, email } from 'vuelidate/lib/validators'
import {formatPhoneNumber} from "@/utils/utils";

export default {
    validations: {
        name: { required },
        email: { required, email },
        select: { required },
        message: { required },
        phone: { maxLength: maxLength(15) },
        allow_subscription: { required }
    },

    data: () => ({
        name: '',
        email: '',
        phone: '',
        message: '',
        allow_subscription: false,
        select: null,
        items: [
            'I am a student',
            'I am a school',
            'I am a landlord',
            'I am... just curious',
        ],
      isSendingMessage: false
    }),
    computed: {
        nameErrors () {
            const errors = []
            if (!this.$v.name.$dirty) return errors
            !this.$v.name.required && errors.push('Name is required.')
            return errors
        },
        selectErrors () {
            const errors = []
            if (!this.$v.select.$dirty) return errors
            !this.$v.select.required && errors.push('Item is required')
            return errors
        },
        emailErrors () {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push('Must be valid e-mail')
            !this.$v.email.required && errors.push('E-mail is required')
            return errors
        },
        phoneErrors() {
          const errors = []
          if (!this.$v.phone.$dirty) return errors;
          !this.$v.phone.maxLength && errors.push('Phone number is too long');
          return errors
        },
        messageErrors () {
            const errors = []
            if (!this.$v.message.$dirty) return errors
            !this.$v.message.required && errors.push('Your message is required')
            return errors
        },
    },
    methods: {
        async submit () {
            this.$v.$touch()
            if (this.$v.$invalid) {
              this.$store.commit('setSnackbar', {
                show: true,
                message: 'Mandatory field(s) required for invite roommate are missing',
                color: 'red'
              });

              return;
            }

            // send contact message
          this.isSendingMessage = true
            await this.$store.dispatch('sendContactMessage', {
                name: this.name,
                senderInfo: this.select,
                email: this.email,
                phoneNumber: this.phone,
                message: this.message
            })

          this.isSendingMessage = false
          this.clear();
        },
        formatPhoneNumber() {
          this.$v.phone.$touch();
          this.phone = formatPhoneNumber(this.phone);
        },
        clear () {
            this.$v.$reset()

            this.name = ''
            this.email = ''
            this.phone = ''
            this.message = ''
            this.select = null
            this.checkbox = false
        },
    },
    beforeMount() {
        // set the menu to normal
        this.$store.commit('setHeaderMenuState');
    }
}
</script>

<style scoped>
    .contact {
        max-width: 540px;
        border: 1px solid #d8d8d8;
        border-radius: 10px;
    }
    .contact h1 {
        font-size: 20px !important;
        font-weight: 700;
    }

    @media (max-width: 1024px) {
        .contact {
            width: 90%;
            margin: 0 auto;
        }
    }
</style>
